/**
 * The viewer's timezone, as a name the Charting Library (v22) accepts.
 *
 * The library takes only its own list of zone names and otherwise draws in
 * UTC. Browsers often report legacy aliases that are not on it — Chrome in
 * India reports "Asia/Calcutta", the library knows "Asia/Kolkata" — so the
 * alias is mapped first; anything still unknown falls back to UTC, which is
 * what the axis would have shown anyway.
 */
export const TV_TIMEZONES = new Set([
  "Etc/UTC", "Africa/Cairo", "Africa/Johannesburg", "Africa/Lagos", "America/Argentina/Buenos_Aires",
  "America/Bogota", "America/Caracas", "America/Chicago", "America/El_Salvador", "America/Juneau",
  "America/Lima", "America/Los_Angeles", "America/Mexico_City", "America/New_York", "America/Phoenix",
  "America/Santiago", "America/Sao_Paulo", "America/Toronto", "America/Vancouver", "Asia/Almaty",
  "Asia/Ashkhabad", "Asia/Bahrain", "Asia/Bangkok", "Asia/Chongqing", "Asia/Dubai", "Asia/Ho_Chi_Minh",
  "Asia/Hong_Kong", "Asia/Jakarta", "Asia/Jerusalem", "Asia/Karachi", "Asia/Kathmandu", "Asia/Kolkata",
  "Asia/Kuwait", "Asia/Manila", "Asia/Muscat", "Asia/Qatar", "Asia/Riyadh", "Asia/Seoul", "Asia/Shanghai",
  "Asia/Singapore", "Asia/Taipei", "Asia/Tehran", "Asia/Tokyo", "Atlantic/Reykjavik", "Australia/ACT",
  "Australia/Adelaide", "Australia/Brisbane", "Australia/Perth", "Australia/Sydney", "Europe/Amsterdam",
  "Europe/Athens", "Europe/Belgrade", "Europe/Berlin", "Europe/Bratislava", "Europe/Brussels",
  "Europe/Bucharest", "Europe/Copenhagen", "Europe/Dublin", "Europe/Helsinki", "Europe/Istanbul",
  "Europe/Lisbon", "Europe/London", "Europe/Luxembourg", "Europe/Madrid", "Europe/Malta", "Europe/Moscow",
  "Europe/Oslo", "Europe/Paris", "Europe/Riga", "Europe/Rome", "Europe/Stockholm", "Europe/Tallinn",
  "Europe/Vilnius", "Europe/Warsaw", "Europe/Zurich", "Pacific/Auckland", "Pacific/Chatham",
  "Pacific/Fakaofo", "Pacific/Honolulu", "Pacific/Norfolk", "US/Mountain",
]);

const ALIASES: Record<string, string> = {
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "Asia/Katmandu": "Asia/Kathmandu",
  "Asia/Chungking": "Asia/Chongqing",
  "Asia/Ashgabat": "Asia/Ashkhabad",
  "Asia/Tel_Aviv": "Asia/Jerusalem",
  "America/Buenos_Aires": "America/Argentina/Buenos_Aires",
  "Europe/Kyiv": "Europe/Helsinki",
  "UTC": "Etc/UTC",
  "Etc/GMT": "Etc/UTC",
  "GMT": "Etc/UTC",
};

export const toTvTimezone = (zone?: string): string => {
  const name = ALIASES[zone ?? ""] ?? zone ?? "";
  return TV_TIMEZONES.has(name) ? name : "Etc/UTC";
};

export const browserTvTimezone = (): string => {
  try {
    return toTvTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return "Etc/UTC";
  }
};
